/** Gerado por scripts/sync-deploy-revision.mjs — não editar manualmente. */
export const DEPLOY_REVISION = '7862cfa51c5a355e41ddda1ef6909efc0148b7a5' as const;
